import React from 'react'
import Seo from '../components/seo/Seo'
import { useBreadcrumbs } from '../seo/useBreadcrumbs'

const Accessibility: React.FC = () => {
  const crumbs = useBreadcrumbs([{ label: 'Accessibility', path: '/accessibility' }], 'light')
  return (
    <div className="bg-sand min-h-screen py-24">
      <Seo
        title="Accessibility Statement | Merritt & Shawn | Coastal Delaware Real Estate"
        description="Our commitment to an accessible website for everyone — contact Shawn McDonnell & Merritt Cooch if you encounter any barrier while browsing Delaware beach real estate."
        path="/accessibility"
        jsonLd={[crumbs.jsonLd]}
      />
      <div className="max-w-3xl mx-auto px-6">
        {crumbs.node}
        <p className="font-display text-[12px] uppercase tracking-[0.3em] font-bold text-accent-gold mb-4">
          Legal
        </p>
        <h1 className="font-display text-4xl md:text-5xl font-bold text-primary-ink tracking-tight mb-10">
          Accessibility Statement
        </h1>
        <div className="space-y-6 text-neutral-charcoal leading-relaxed font-sans">
          <p>
            Merritt & Shawn | Coastal Delaware Real Estate is committed to ensuring digital accessibility for people with disabilities.
            We continually work to improve the user experience for everyone and apply relevant accessibility
            standards, aiming for conformance with the Web Content Accessibility Guidelines (WCAG) 2.1 Level
            AA.
          </p>
          <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide">
            What we do
          </h2>
          <p>
            This site includes an accessibility widget (bottom corner of every page) offering larger text,
            high contrast, grayscale, underlined links, and a readable font. The site honors the{' '}
            <code className="text-sm">prefers-reduced-motion</code> setting, uses semantic landmarks and
            keyboard-navigable controls, and provides text alternatives for meaningful imagery.
          </p>
          <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide">
            Feedback
          </h2>
          <p>
            If you experience any difficulty accessing content on this site, or notice any accessibility
            issues, please let us know — we take your feedback seriously and will work to provide the
            information you need through an accessible format:
          </p>
          <p>
            <a href="mailto:shawn@jacklingo.com" className="text-accent-gold hover:underline">
              shawn@jacklingo.com
            </a>
            {' · '}
            <a href="tel:+13026452207" className="text-accent-gold hover:underline">
              302-645-2207
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Accessibility
